import { HttpClient } from '@shared/adapters/HttpClient';
import { OrdersApiAdapter } from '@modules/Orders/ViewOrders/adapters/OrdersApiAdapter';
import { CRMApiAdapter } from '../../List/adapters/CRMApiAdapter';
import type { CRMOrder } from '../models/CRMOrder';

export class CRMOrderApiAdapter {
  private ordersApiAdapter: OrdersApiAdapter;
  private crmApiAdapter: CRMApiAdapter;

  constructor(httpClient: HttpClient, crmApiAdapter: CRMApiAdapter) {
    this.ordersApiAdapter = new OrdersApiAdapter(httpClient);
    this.crmApiAdapter = crmApiAdapter;
  }

  /**
   * Obtiene un pedido completo con datos de Orders y CRM
   * @param orderId ID del pedido
   * @returns Pedido combinado con datos de Orders y CRM (tags, notas, estado CRM)
   */
  async getCRMOrderById(orderId: number): Promise<CRMOrder> {
    // Obtener datos del pedido desde Orders API
    const orderData = await this.ordersApiAdapter.getOrderById(orderId);

    // Obtener datos de CRM desde la lista de CRM
    // Buscar el pedido en la lista de CRM para obtener tags, notas y estado CRM
    const crmListResponse = await this.crmApiAdapter.getCRMPaginated({
      search: orderData.ref,
      page: 1,
      limit: 1,
    });
    
    const crmOrderData = crmListResponse.orders.find((o: any) => o.id === orderId);
    
    // Combinar los datos
    const crmOrder: CRMOrder = {
      ...orderData,
      crm_status: crmOrderData?.crm_status || [],
      tags: crmOrderData?.tags || [],
      notes: crmOrderData?.notes || [],
    };

    return crmOrder;
  }
}
